import React from 'react'
import moment from 'moment'
import { IconButton } from '@material-ui/core'
import ShowIcon from '@material-ui/icons/FindInPage'
import AdvertisementMenuActions from './AdvertisementActions'
import TextFilter from '../common/table/filters/TextFilter'
import SelectFilter from '../common/table/filters/SelectFilter'
import { statuses } from '../../models/advertisements/AdvertisementModel'

/* eslint react/display-name: 0, react/prop-types: 0 */
export const columns = (onEdit, onPublish, onDelete, busy) => [
  {
    Header: '',
    id: 'details',
    width: 45,
    sortable: false,
    filterable: false,
    Cell: row => (
      <IconButton
        aria-label='Szczegóły reklamy'
        disabled={busy}
        onClick={() => onEdit(row.original.id)}
        style={{ padding: 2 }}
      >
        <ShowIcon />
      </IconButton>
    )
  },
  {
    Header: 'Akcje',
    id: 'actions',
    width: 70,
    sortable: false,
    filterable: false,
    Cell: row => (
      <AdvertisementMenuActions
        advertisement={row.original}
        onPublish={onPublish}
        onDelete={onDelete}
        busy={busy}
      />
    )
  },
  {
    Header: 'Nazwa',
    accessor: 'name',
    Filter: ({ filter, onChange }) => (
      <TextFilter filter={filter} onChange={onChange} label='filtruj...' />
    )
  },
  {
    Header: 'Status',
    id: 'status',
    accessor: row =>
      statuses[row.status] ? statuses[row.status].name : row.status,
    Filter: ({ filter, onChange }) => (
      <SelectFilter
        filter={filter}
        onChange={onChange}
        items={statuses}
        label='filtruj...'
      />
    )
  },
  {
    Header: 'Data utworzenia',
    id: 'createdAt',
    accessor: row => row.createdAt ? moment(row.createdAt).format('DD.MM.YYYY HH:mm:ss') : '-',
    filterable: false
  },
  {
    Header: 'Ważna od',
    id: 'validFrom',
    accessor: row =>row.validFrom ? moment(row.validFrom).format('DD.MM.YYYY HH:mm:ss') : '-',
    filterable: false
  },
  {
    Header: 'Ważna do',
    id: 'validTo',
    accessor: row => row.validTo ? moment(row.validTo).format('DD.MM.YYYY HH:mm:ss') : '-',
    filterable: false
  },
  { Header: 'Kolejność', accessor: 'order', filterable: false },
  {
    Header: 'Operatorzy',
    id: 'tenantScope',
    filterId: 'tenant',
    accessor: row => (row.tenantScope || []).join(', '),
    sortable: false,
    Filter: ({ filter, onChange }) => (
      <TextFilter
        filter={filter}
        onChange={onChange}
        label='Identyfikator operatora'
      />
    )
  }
]
